import apiClient from '../index';

export const spPhotoApi = {
  getPhotos: () => apiClient.get('/service-provider/photos'),
  getPhoto: (id) => apiClient.get(`/service-provider/photos/${id}`),
  uploadPhoto: (formData) => apiClient.post('/service-provider/photos', formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  }),
  updatePhoto: (id, data) => apiClient.put(`/service-provider/photos/${id}`, { photos: data }),
  deletePhoto: (id) => apiClient.delete(`/service-provider/photos/${id}`),
};

export default spPhotoApi;
